import { useMemo } from "react";
import { Box } from "@mui/material";
import { tokens } from "../../theme";
import { markdownAHtml } from "../../utils/markdown";

/**
 * Texto con formato Markdown, en la tipografía de un comentario (no la de una página).
 *
 * El HTML sale de `markdownAHtml`, que escapa todo antes de dar formato: por eso se
 * puede pintar con `dangerouslySetInnerHTML` aunque lo haya escrito cualquiera.
 */
export default function Markdown({ texto }: { texto: string }) {
  const html = useMemo(() => markdownAHtml(texto), [texto]);
  return (
    <Box
      sx={{
        typography: "body2",
        color: "text.primary",
        "& p": { my: 0.75 },
        "& p:first-of-type": { mt: 0 },
        "& p:last-child": { mb: 0 },
        "& h4": { fontSize: 14.5, fontWeight: 600, mt: 1.5, mb: 0.5 },
        "& ul, & ol": { pl: 2.5, my: 0.75 },
        "& li": { mb: 0.25 },
        "& blockquote": { m: 0, my: 0.75, pl: 1.5, borderLeft: "3px solid", borderColor: "divider", color: "text.secondary" },
        "& code": { fontFamily: "monospace", fontSize: 13, bgcolor: "action.hover", px: 0.5, borderRadius: 0.5 },
        "& a": { color: tokens.marca.enlace, fontWeight: 600 },
      }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
